import { gql } from '@apollo/client';

import { AssignmentFragment } from '../fragments';
import { Assignment } from '../../types';

export interface GetAssignmentsQueryVariables {
  courseId: string;
}

export interface GetAssignmentsQueryResult {
  assignments: Assignment[];
}

export const getAssignmentsQuery = gql`
  query GetAssignmentsQuery($courseId: String!) {
    assignments(courseId: $courseId) @rest(type: "Assignment", path: "courses/{args.courseId}/assignments") {
      ...Assignment
    }
  }
  ${AssignmentFragment}
`;
